import { render, staticRenderFns } from "./PackageEditTabInformation.vue?vue&type=template&id=62d2b139"
import script from "./PackageEditTabInformation.vue?vue&type=script&lang=js"
export * from "./PackageEditTabInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports